export default __webpack_public_path__ + "static/media/add.60b4eeda.svg";